import React, { useState, useEffect , useRef, useMemo} from "react";
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemText,
    TextField,
    Button,
    Link,
    Autocomplete,
    Chip,
    Grid,
    //Select,
    //MenuItem,
    RadioGroup, FormControlLabel, Radio} from "@mui/material";
//import { DropdownMenu, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuContent } from "@/components/ui";

import { Dialog, DialogTitle, DialogContent, IconButton, Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import AddPersonIcon from "@mui/icons-material/PersonAdd";
import AddBusinessIcon from "@mui/icons-material/AddBusiness";
import ReplyIcon from "@mui/icons-material/Reply";
import ReplyAllIcon from "@mui/icons-material/ReplyAll";
import ForwardIcon from "@mui/icons-material/Forward";
import NewIcon from "@mui/icons-material/AddBox";
import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import BlockIcon from "@mui/icons-material/Block";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import CustomerDialog from "./CustomerDialog";

import { API_BASE_URL } from "../config.ts";
import axiosExt from '../axios';
import { Email, Order, User, Contact, Customer,MessageTemplate, EmailTypeList } from "../types";
import { extractEmailAddress, populateTemplate, escapeRegExp } from "../utils/helpers.ts";
import AddContactDialog from "./AddContactDialog";
import AddIgnoreDialog from "./AddIgnoreDialog";
import DOMPurify from "dompurify";
import { useTranslation } from "react-i18next";
import ReactQuill from "react-quill";
import CustomQuillEditor from "./CustomQuillEditor";
import FieldSelectionPopup from "./FieldSelectionPopup";
import "react-quill/dist/quill.snow.css";
import { Tabs, Tab } from "@mui/material";
import type { EditableOrderField } from "../types/index";
import { useSnackbar } from 'notistack';


interface EmailConversationProps {
    selectedOrder: Order;
    currentUser: User;
    contacts: Contact[];
    unassignedContacts?: Contact[]; // Optional prop for unassigned contacts
    customers: Customer[];
    users: User[]; 
    headerStart?: React.ReactNode;
    onFieldValueSelected: (field: EditableOrderField, fieldValue: string) => void;
    setCustomers: React.Dispatch<React.SetStateAction<Customer[]>>;
    setContacts: React.Dispatch<React.SetStateAction<Contact[]>>;
    onUpdateCustomerForOrder: (customerId:string) => void;
}

const EmailConversation: React.FC<EmailConversationProps> = ({ selectedOrder, currentUser, contacts, unassignedContacts, customers, users, headerStart, onFieldValueSelected
    , setCustomers, setContacts, onUpdateCustomerForOrder }) => {
    const { t } = useTranslation();

    const [emails, setEmails] = useState<Email[]>([]);
    const [emailContents, setEmailContents] = useState<{ [id: string]: string }>({});

    const previousEmailIdsRef = useRef<Set<string>>(new Set());
    const [currentOrderNumberEmailsLoaded, setCurrentOrderNumberEmailsLoaded] = useState<string | null > (null);
    //const [loading, setLoading] = useState(false);
    //const [emailToSend, setEmailToSend] = useState<Email | null>(null);
    //const emailToSend = useRef(null);
    //const [selectedCustomerId, setSelectedCustomerId] = useState("");
    const [replyMessage, setReplyMessage] = useState("");
    const [replySubject, setReplySubject] = useState("");
    const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
    const [toRecipients, setToRecipients] = useState<string[]>([]);
    const [ccRecipients, setCcRecipients] = useState<string[]>([]);
    const [threadId, setThreadId] = useState<string | null>("");
    const [newToEmail, setNewToEmail] = useState("");
    const [newCcEmail, setNewCcEmail] = useState("");
    const [showReplySection, setShowReplySection] = useState(false);
    const replyInputRef = useRef<ReactQuill>(null);

    const [showNewToField, setShowNewToField] = useState(false);
    const [showNewCcField, setShowNewCcField] = useState(false);
    const [templates, setTemplates] = useState<MessageTemplate[]>([]);
    const [showAttachmentDialog, setShowAttachmentDialog] = useState(false);
    const [selectedBlobAttachments, setSelectedBlobAttachments] = useState<{ fileName: string; fileUrl: string }[]>([]);
    const [replyEmailId, setReplyEmailId] = useState<string | null>(null);

    const [replyEditorKey, setReplyEditorKey] = useState<number>(0);

    const [emailOptions, setEmailOptions] = useState<string[]>([]);
    const [selectedEmail, setSelectedEmail] = useState<string | null>('');
    const [draftToDelete, setDraftToDelete] = useState<Email | null>(null);
    const [deletedBlobFileUrls, setDeletedBlobFileUrls] = useState<string[]>([]);
    const [filesUploadedToDraft, setFilesUploadedToDraft] = useState<string[]>([]);

    const [addContactDialogOpen, setAddContactDialogOpen] = useState(false);
    //const markAsReadTimeout = useRef<NodeJS.Timeout | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const [expandedEmails, setExpandedEmails] = useState<{ [emailId: string]: boolean }>({});

    const [showIgnoreDialog, setShowIgnoreDialog] = useState(false);
    const [ignoreEmail, setIgnoreEmail] = useState<string | null>(null);

    const [showCustomerDialog, setShowCustomerDialog] = useState(false);
    const [newCustomer, setNewCustomer] = useState<Customer | null>(null);

    const [recentlyMarkedAsRead, setRecentlyMarkedAsRead] = useState<string[]>([]);
    const [recentlyMarkedAsUnread, setRecentlyMarkedAsUnread] = useState<string[]>([]);

    const [pendingEmail, setPendingEmail] = useState<string | null>(null);

    const [settings, setSettings] = useState<Record<string, string>>({});
    //const domain = pendingEmail?.split("@")[1]?.toLowerCase();
    //const matchingCustomers = customers.filter(c =>
    //    c.email?.toLowerCase() === pendingEmail?.toLowerCase() ||
    //    c.webDomain?.toLowerCase() === domain
    //);

    
    const [sending, setSending] = useState(false);
    const [hasUserTyped, setHasUserTyped] = useState(false);
    const { enqueueSnackbar } = useSnackbar();

    const [showFieldPopup, setShowFieldPopup] = useState(false);
    const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });
    const [selectedText, setSelectedText] = useState("");

    const [readStatusFilter, setReadStatusFilter] = useState(() => {
        return localStorage.getItem("readStatusFilter") || "All"; // Default to Inbox
    }); 

    const [selectedTab, setSelectedTab] = useState<string>('All');
    const CUSTOMS_EMAIL_COLOR = "#d6f5d6";

    const [emailViewFilter, setEmailViewFilter] = useState(() => {
        return localStorage.getItem("emailViewFilter") || "Inbox"; // Default to Inbox
    });

    const fetchSettings = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axiosExt.get(`${API_BASE_URL}/settings`, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                },
            });
            setSettings(response.data);
        } catch (error) {
            console.error("Error fetching settings:", error);
        } 
    };

    const handleAddCustomerClick = (email: string) => {
        const domain = email.split("@")[1]?.toLowerCase();
        const publicDomains = ["gmail.com", "hotmail.com", "outlook.com"];

        setNewCustomer({
            id: "",
            email,
            name: "",
            webDomain: publicDomains.includes(domain) ? "" : domain,
            phone: "",
            accountingCustomerNumber: "",
            activity: "",
            payType: "",
            notes: "",
        });

        setShowCustomerDialog(true);
    };


    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const fileList = event.target.files;
        if (!fileList || fileList.length === 0) return; // ✅ Prevents null issues

        // ✅ Convert FileList to Array & Filter out files with size 0
        const newFiles = Array.from(fileList).filter(file => file.size > 0);

        if (newFiles.length === 0) {
            console.warn("No valid files selected.");
            return;
        }

        setSelectedFiles(prevFiles => [...prevFiles, ...newFiles]);

        // Reset input to allow re-selecting the same file again
        event.target.value = "";
    };

    const handleDownloadAttachment = async (fileId: string, downloadAsFileName: string) => {
        try {
            const token = localStorage.getItem("token");

            // Step 1: Get the file URL from your backend
            const response = await axiosExt.get(`${API_BASE_URL}/emails/download/${fileId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            const fileUrl = response.data.fileUrl;

            // Step 2: Download file as blob from Azure Blob Storage
            const fileResponse = await axiosExt.get(fileUrl, { responseType: 'blob' });

            const hasExtension = /\.[^/.]+$/.test(downloadAsFileName);
                        
            const blob = hasExtension
                ? new Blob([fileResponse.data])
                : new Blob([fileResponse.data], { type: 'application/octet-stream' });

            //const blob = new Blob([fileResponse.data]);
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = downloadAsFileName;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("Error downloading the file:", error);
            alert("Failed to download the file.");
        }
    };

    const handleForwardEmail = async (email: Email) => {
        setToRecipients([]);
        setCcRecipients([]);
        setNewToEmail("");
        setNewCcEmail("");
        //setThreadId(""); // no thread linking
        setReplySubject(`${t("Fwd")}: ${email.subject ?? ""}`);
        //setReplyMessage(
        //    buildReplyMessage(
        //        `<b>${t("From")}:</b> ${email.from || ''}<br /><b>${t("To")}:</b> ${email.to || ''}<br /><b>${t("CC")}:</b> ${email.cc || ''}<br /><b>${t("Subject")}:</b> ${email.subject || ''}<br /><br />${email.content || ''}`
        //    )
        //);
        const body = await ensureEmailContent(email);
        setReplyMessage(buildReplyMessageOutlook({ ...email, content: body }));


        // Include original attachments (Azure Blob ones)
        setSelectedBlobAttachments(
            (email.attachments || []).map(a => ({
                fileName: a.fileName,
                fileUrl: a.fileUrl
            }))
        );

        setShowReplySection(true);
        setReplyEditorKey(prev => prev + 1);
        setTimeout(() => replyInputRef.current?.getEditor()?.focus(), 100);
        
    };


    const markEmailAsRead = async (emailId: string) => {

        const token = localStorage.getItem("token");
        try {
            const response = await axiosExt.put(
                `${API_BASE_URL}/emails/${emailId}/mark-as-read`,
                {}, // PUT requires a body, even if empty
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            //email.isRead = true; // Update the email object directly
            setEmails((prev) =>
                prev.map((e) => (e.id === selectedEmail ? { ...e, isRead: true } : e))
            );

            setRecentlyMarkedAsRead(prev => [...prev, emailId]);
            setRecentlyMarkedAsUnread(prev => {
                const updated = prev.filter(id => id !== emailId);
                return updated;
            });
            return response.data;
        } catch (error) {
            console.error("Failed to mark email as read", error);
        }
    };

    const markEmailAsUnread = async (emailId: string) => {
        const token = localStorage.getItem("token");
        try {
            const response = await axiosExt.put(
                `${API_BASE_URL}/emails/${emailId}/mark-as-unread`,
                {}, // PUT requires a body, even if empty
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );
            //email.isRead = false; // Update the email object directly
            setEmails((prev) =>
                prev.map((e) => (e.id === selectedEmail ? { ...e, isRead: false } : e))
            );

            setRecentlyMarkedAsUnread(prev => [...prev, emailId]);
            // Explicitly remove from recentlyMarkedAsRead
            setRecentlyMarkedAsRead(prev => {
                const updated = prev.filter(id => id !== emailId);
                return updated;
            });
            return response.data;
        } catch (error) {
            console.error("Failed to mark email as read", error);
        }

    };

    const handleEmailViewChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selected = event.target.value;
        setEmailViewFilter(selected);
        localStorage.setItem("emailViewFilter", selected);
    };

    const handleReadStatusFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const selected = event.target.value;
        setReadStatusFilter(selected);
        localStorage.setItem("readStatusFilter", selected);
    };

    const handleShowReplyClick = (nextShowReply: boolean) => {
        const filteredAndSortedEmails = [...filterEmails(users)].sort(
            (a, b) => new Date(b.receivedAt || 0).getTime() - new Date(a.receivedAt || 0).getTime()
        );
        const firstEmailInTab = filteredAndSortedEmails[0];
        if (firstEmailInTab) {
            const currentSender = selectedEmail?.toLowerCase().trim();
            const previousSender = firstEmailInTab.from?.toLowerCase().trim();

            // Gather recipients from previous To
            const previousTo = (firstEmailInTab.to?.split(";") || []).map(e => e.trim());

            // Build new list: previous sender + previous To - current sender
            const combinedRecipients = [
                previousSender,
                ...previousTo
            ]
                .filter(Boolean) // remove empty
                .map(email => email.toLowerCase())
                .filter((email, index, self) =>
                    email !== currentSender && self.indexOf(email) === index // remove current sender & duplicates
                );

            setThreadId(firstEmailInTab.threadId ? firstEmailInTab.threadId : "");
            setToRecipients(combinedRecipients);
            setCcRecipients((firstEmailInTab.cc?.split(";") || []).map(e => e.trim()).filter((email, index, self) =>
                email !== currentSender && self.indexOf(email) === index // remove current sender & duplicates
            ));
        }
        else
            return;

        setShowReplySection(nextShowReply);

        if (nextShowReply) {
            setReplyEditorKey(prev => prev + 1);
            setTimeout(() => {
                replyInputRef.current?.getEditor()?.focus();
            }, 100);
        }
    };

    const handleReplyAll = async (email: Email) => {
        const currentSender = extractEmailAddress(selectedEmail?.toLowerCase() ?? "");

        const previousSender = extractEmailAddress(email.from ?? "").toLowerCase();
        const previousTo = (email.to?.split(";") || []).map(e => extractEmailAddress(e).toLowerCase().trim());
        const previousCc = (email.cc?.split(";") || []).map(e => extractEmailAddress(e).toLowerCase().trim());

        const combinedRecipients = [
            previousSender,
            ...previousTo
        ]
            .filter(email => email && email !== currentSender)
            .filter((email, index, self) => self.indexOf(email) === index);

        const combinedCc = previousCc
            .filter(email => email && email !== currentSender)
            .filter((email, index, self) => self.indexOf(email) === index);

        const rePrefix = t("Re");
        const subjectLine = email.subject?.startsWith(`${rePrefix}:`) ? email.subject : `${rePrefix}: ${email.subject}`;

        //const subjectLine = email.subject?.startsWith("Re:") ? email.subject : `Re: ${email.subject}`;

        setToRecipients(combinedRecipients);
        setCcRecipients(combinedCc);
        setNewToEmail("");
        setNewCcEmail("");
        setThreadId(email.threadId ? email.threadId : "");
        setReplySubject(subjectLine);
        //setReplyMessage(
        //    buildReplyMessage(
        //        `<b>${t("From")}:</b> ${email.from || ''}<br /><b>${t("To")}:</b> ${email.to || ''}<br /><b>${t("CC")}:</b> ${email.cc || ''}<br /><b>${t("Subject")}:</b> ${email.subject || ''}<br /><br />${email.content || ''}`
        //    )
        //);
        const body = await ensureEmailContent(email);
        setReplyMessage(buildReplyMessageOutlook({ ...email, content: body }));

        setShowReplySection(true);
        setReplyEditorKey(prev => prev + 1);
        setTimeout(() => replyInputRef.current?.getEditor()?.focus(), 100);
        
    };

    /*const fetchOrderForTemplate = async (id: string): Promise<Order | null> => {
        const token = localStorage.getItem("token");
        try {
            const response = await axiosExt.get<Order>(`${API_BASE_URL}/orders/${id}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            return response.data;
        } catch (error) {
            console.error("Error fetching order for template:", error);
            return null;
        }
    };*/
    /*useEffect(() => {
        if (selectedOrder) {
            fetchEmails();
            fetchTemplates();
            setReplySubject("Re: " + (selectedOrder?.initialEmailSubject ?? ""));

        }
    }, [selectedOrder]);*/

    const prevOrderIdRef = useRef<string>();

    useEffect(() => {
        const handleMouseUp = (e: MouseEvent) => {
            const selection = window.getSelection();
            const text = selection?.toString().trim();
            if (!text) {
                setShowFieldPopup(false);
                return;
            }

            const range = selection?.getRangeAt(0);
            const rect = range?.getBoundingClientRect();
            if (!rect) return;

            setSelectedText(text);

            const popupHeight = 300; // estimated
            const verticalOffset = 10;
            const scrollY = window.scrollY;
            const scrollX = window.scrollX;

            const mouseY = e.clientY;
            const mouseX = e.clientX;

            const spaceBelow = window.innerHeight - mouseY;
            const showAbove = spaceBelow < popupHeight + verticalOffset;

            const top = showAbove
                ? mouseY + scrollY - popupHeight - verticalOffset // above mouse
                : mouseY + scrollY + verticalOffset;              // below mouse

            const left = mouseX + scrollX;

            setPopupPosition({ top: Math.max(top, 0), left });
            setShowFieldPopup(true);

        };

        fetchSettings();
        fetchTemplates();


        const container = document.getElementById("email-container");
        container?.addEventListener("mouseup", handleMouseUp);

        return () => {
            container?.removeEventListener("mouseup", handleMouseUp);
        };
    }, []);

    useEffect(() => {
        
        const handleEmailUpdate = (event: Event) => {
            //console.log("order-email-updated event caught");

            const customEvent = event as CustomEvent<{ orderId: string }>;
            //console.log("Selected order ID:", selectedOrder?.id);
            //console.log("Event order ID:", customEvent.detail?.orderId);

            if (!customEvent.detail || customEvent.detail.orderId !== selectedOrder?.id) return;

            void (async () => {
                try {
                    const token = localStorage.getItem("token");
                    const response = await axiosExt.get<Email[]>(
                        `${API_BASE_URL}/orders/${selectedOrder.id}/emails`,
                        {
                            headers: { Authorization: `Bearer ${token}` },
                        }
                    );

                    const newEmails = response.data;
                    const newEmailIds = new Set(newEmails.map(e => e.id));
                    const previousEmailIds = previousEmailIdsRef.current;

                    const hasNew =
                        newEmails.length !== previousEmailIds.size ||
                        newEmails.some(e => !previousEmailIds.has(e.id));

                    if (hasNew) {
                        setEmails(newEmails);
                        previousEmailIdsRef.current = newEmailIds;

                        const newest = [...newEmails].sort((a, b) =>
                            new Date(b.receivedAt ?? 0).getTime() -
                            new Date(a.receivedAt ?? 0).getTime()
                        )[0];
                        
                        
                        setExpandedEmails(prev => ({
                            ...prev,
                            [newest.id]: true,
                        }));
                        fetchEmailContent(newest.id);



                        //if ((selectedOrder.assignedToUserId?.trim().toLowerCase() === currentUser.id?.trim().toLowerCase())) {
                        //    if (!sortedEmails[0].isRead) {
                        //        await markEmailAsRead(sortedEmails[0].id || "");
                        //        setEmails((prev) =>
                        //            prev.map((e) => (e.id === selectedEmail ? { ...e, isRead: true } : e))
                        //        );
                        //    }
                        //}


                    }
                } catch (err) {
                    console.error("Failed to update emails from event:", err);
                }
            })();
        };

        window.addEventListener("order-email-updated", handleEmailUpdate);

        if (!selectedOrder || prevOrderIdRef.current === selectedOrder.id) return;

        setShowReplySection(false);
        setThreadId("");
        setToRecipients([]);
        setCcRecipients([]);
        setReplySubject("");
        setReplyMessage("");
        setNewToEmail("");
        setNewCcEmail("");

        prevOrderIdRef.current = selectedOrder.id;
        setShowReplySection(false); //close reply selection when order changes
        fetchEmails();
        //fetchTemplates();

        const rePrefix = t("Re");
        const subjectLine = selectedOrder.initialEmailSubject?.startsWith(`${rePrefix}:`) ? selectedOrder.initialEmailSubject : `${rePrefix}: ${selectedOrder.initialEmailSubject}`;
        setReplySubject(subjectLine);

        return () => {
            window.removeEventListener("order-email-updated", handleEmailUpdate);
        };
    }, [selectedOrder?.id]);

    useEffect(() => {
        if (emails.length > 0 && selectedEmail) {
            const latestEmail = emails[0];

            const currentSender = selectedEmail.toLowerCase().trim();
            const previousSender = latestEmail.from?.toLowerCase().trim();

            // Gather recipients from previous To
            const previousTo = (latestEmail.to?.split(";") || []).map(e => e.trim());

            // Build new list: previous sender + previous To - current sender
            const combinedRecipients = [
                previousSender,
                ...previousTo
            ]
                .filter(Boolean) // remove empty
                .map(email => email.toLowerCase())
                .filter((email, index, self) =>
                    email !== currentSender && self.indexOf(email) === index // remove current sender & duplicates
                );

            setThreadId(latestEmail.threadId);
            setToRecipients(combinedRecipients);
            setCcRecipients((latestEmail.cc?.split(";") || []).map(e => e.trim()));
        }
    }, [emails, selectedEmail]);

    useEffect(() => {
        setRecentlyMarkedAsRead([]);
        setRecentlyMarkedAsUnread([]);
    }, [readStatusFilter]);


    //const handleDeleteAttachment = (fileName: string) => {
    //    setSelectedFiles(prevFiles => prevFiles.filter(file => file.name !== fileName));
    //};
    const handleDeleteAttachment = (fileName: string, type: "local" | "blob") => {
        if (type === "local") {
            setSelectedFiles(prevFiles => prevFiles.filter(file => file.name !== fileName));
        } else {
            //setSelectedBlobAttachments(prev => prev.filter(file => file.fileName !== fileName));
            const removed = selectedBlobAttachments.find(f => f.fileName === fileName);
            if (removed) {
              setDeletedBlobFileUrls(prev => [...prev, removed.fileUrl]);
              setSelectedBlobAttachments(prev => prev.filter(f => f.fileName !== fileName));
            }
        }
    };

    const fetchTemplates = async () => {
        try {
            const token = localStorage.getItem("token");
            const response = await axiosExt.get(`${API_BASE_URL}/messageTemplates`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setTemplates(response.data);
        } catch (error) {
            console.error("Failed to fetch templates:", error);
        }
    };

    const fetchEmailContent = async (emailId: string): Promise<string> => {
        if (emailContents[emailId]) {
            return emailContents[emailId];
        }

        const token = localStorage.getItem("token");
        try {
            const response = await axiosExt.get(`${API_BASE_URL}/emails/${emailId}/content`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            let content: string;
            if (response.data.source === "blob") {
                const blobResp = await axiosExt.get(response.data.url, { responseType: "text" });
                content = blobResp.data;
            } else {
                content = response.data.content;
            }

            // keep it in state for later renders
            setEmailContents(prev => ({ ...prev, [emailId]: content }));

            return content;
        } catch (err) {
            console.error("Failed to fetch email content", err);
            return "";
        }
    };

    const fetchEmails = async () => {
        //setLoading(true);
        setCurrentOrderNumberEmailsLoaded("");
        try {
            const token = localStorage.getItem("token");
            //const searchParam = customerId ? `search=${customerId}` : "";
            
            const response = await axiosExt.get<Email[]>(`${API_BASE_URL}/orders/${selectedOrder.id}/emails`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`,
                },
            }
            );
            if (response.status === 401) {
                throw new Error("Unauthorized. Please log in again.");
            }

            setEmails(response.data);
            const sortedEmails = [...response.data].sort(
                (a, b) => new Date(b.receivedAt || 0).getTime() - new Date(a.receivedAt || 0).getTime()
            );
            const initialExpanded: { [emailId: string]: boolean } = {};
            if (response.data.length > 0) {
                //setSelectedEmail(sortedEmails[0].id);
                const firstEmail = sortedEmails[0];
                initialExpanded[response.data[0].id] = true; // expand the first email
                setExpandedEmails(initialExpanded);
                await fetchEmailContent(firstEmail.id);

                if ((selectedOrder.assignedToUserId?.trim().toLowerCase() === currentUser.id?.trim().toLowerCase())) {
                    if (!sortedEmails[0].isRead) {
                        await markEmailAsRead(sortedEmails[0].id || "");
                    }
                }
            }
            
            // Fetch from-emails
            const fromEmailResponse = await axiosExt.get(`${API_BASE_URL}/emails/from-email`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            const data = fromEmailResponse.data;
            if (typeof data === "string") {
                const emailsArray = data
                    .split(",")
                    .map(email => email.trim())
                    .filter(email => email.length > 0);

                setEmailOptions(emailsArray);

                // Step 3: Match most recent "to"
                if (emailsArray.length > 0 && sortedEmails.length > 0) {
                    const recentTo = sortedEmails[0].to;
                    const match = emailsArray.find(email => email === recentTo);
                    const fallback = emailsArray[0];
                    setSelectedEmail(match || fallback);
                }
            }


            //setReplyMessage(
            //    buildReplyMessage(
            //        `<b>${t("From")}:</b> ${sortedEmails[0]?.from || ''}<br /><b>${t("To")}:</b> ${sortedEmails[0]?.to || ''}<br /><b>${t("CC")}:</b> ${sortedEmails[0]?.cc || ''}<br /><b>${t("Subject")}:</b> ${sortedEmails[0]?.subject || ''}<br /><br />${sortedEmails[0]?.content || ''}`
            //    )
            //);
            setReplyMessage(
                buildReplyMessageOutlook(sortedEmails[0])
            );


        } catch (error) {
            setEmails([]);
            console.error("Error fetching emails for order:", error);
        } finally {
            setCurrentOrderNumberEmailsLoaded(selectedOrder.internalNumber ?? null);
            //setLoading(false);
        }

    };

    /*const mapEmailToContact = (email: string): string => {
        const contact = contacts.find(contact => contact.email === email);
        return contact ? `${contact.firstName} ${contact.lastName} (${contact.email})` : email;
        //return contact ? `${contact.firstName} ${contact.lastName}` : email;
    };*/

    // Handle file selection
    /*const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            setSelectedFile(event.target.files[0]);
        }
    };*/
    const getDisplayName = (email: string, contacts: Contact[]) => {
        const contact = contacts.find(c => c.email === email);
        return contact ? `${contact.firstName} ${contact.lastName} <${contact.email}>` : email;
    };

    const formatEmails = (emailString: string, contacts: Contact[]) => {
        
        if (!emailString) return "";
        return emailString
            .split(";")
            .map(email => getDisplayName(email, contacts))
            .join(", ");
    };

    /*const handleReplyChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        setReplyMessage(e.target.value);
    }*/

    const ensureEmailContent = async (email: Email) => {
        if (!emailContents[email.id]) {
            const content = await fetchEmailContent(email.id);
            return content || "";
        }
        else
            return emailContents[email.id];
    };

    const buildReplyMessage = (prependContent: string = "") => {
        return `<br />${currentUser?.emailSignature || ''}<br /><br />${prependContent}`;
    };

    const buildReplyMessageOutlook = (originalEmail?: Email) => {
        const signature = currentUser?.emailSignature ?? "";
        if (!originalEmail) return `<br />${signature}<br /><br />`;

        const date = new Date(originalEmail.receivedAt + "Z");

        const formattedDate = date.toLocaleString(undefined, {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
        });

        const formatField = (label: string, value?: string | null) =>
            value ? `<b>${t(label)}:</b> ${value}<br />` : "";

        const headerBlock = `
  <br />
  <div style="border-top:1px solid #ccc; padding-top:10px; margin-top:16px; white-space: pre-wrap;">
    ${[
                formatField("From", originalEmail.from),
                formatField("Sent", formattedDate),
                formatField("To", originalEmail.to),
                formatField("Cc", originalEmail.cc),
                formatField("Subject", originalEmail.subject)
        ].filter(Boolean).join("")}
    <br />
  </div>
`;


        //const cleanedContent = originalEmail.content || "";
        const loadedContent = emailContents[originalEmail.id] ?? originalEmail.content ?? "";

        //TBD clean content
        return `<br />${signature}<br />${headerBlock}${loadedContent}`;
    }

    const handleReplyChange = (value: string) => {
        setHasUserTyped(true);
        setReplyMessage(value);
    };

    const handleSendReply = async (saveOnly = false) => {
        if (!replyMessage.trim()) {
            alert("Please enter a reply message.");
            return;
        }

        setSending(true); // Start sending

        if (newToEmail.trim()) {
            const extraEmails = newToEmail
                .split(";")
                .map(e => e.trim())
                .filter(e => e && !toRecipients.includes(e));

            setToRecipients(prev => [...prev, ...extraEmails]);
        }

        const formattedToRecipients = [...toRecipients, ...newToEmail.split(";")].filter(email => email.trim() !== "").join(";");
        const formattedCcRecipients = [...ccRecipients, ...newCcEmail.split(";")].filter(email => email.trim() !== "").join(";");

        // Step 1: Create Email (without attachments)
        const emailData = {
            from: selectedEmail,
            to: formattedToRecipients,
            cc: formattedCcRecipients,
            bcc: "",
            subject: replySubject,
            content: saveOnly
                ? replyMessage // just raw user message for drafts
                : replyMessage,
            messageId: "",
            orderId: selectedOrder.id,
            threadId: threadId,
            receivedAt: new Date(),
            isDraft: saveOnly,
            isRead: true,
        };

        const emailUpdatePayload = {
            subject: replySubject,
            content: replyMessage,
            to: toRecipients.join(";"),
            cc: ccRecipients.join(";"),
            bcc: "",
            threadId: threadId,
            isDraft: saveOnly,
        };
        
        try {
            const token = localStorage.getItem("token");

            const isEditingDraft = Boolean(replyEmailId);
            const method = isEditingDraft ? "put" : "post";
            //const url = isEditingDraft
            //    ? `${API_BASE_URL}/emails/draft/${replyEmailId}` // Update existing draft
            //    : `${API_BASE_URL}/emails?orderNo=${selectedOrder.internalNumber}`; // Create new draft

            const url = isEditingDraft
                ? `${API_BASE_URL}/emails/draft/${replyEmailId}` // Update existing draft
                : `${API_BASE_URL}/emails?orderId=${selectedOrder.id}&orderNo=${selectedOrder.internalNumber}`; // Create new draft


            if (replyEmailId && deletedBlobFileUrls.length > 0) {
                await axiosExt.delete(`${API_BASE_URL}/emails/draft/${replyEmailId}/attachments`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json"
                    },
                    data: deletedBlobFileUrls
                });
            }

            const emailResponse = await axiosExt[method](url, method === "post" ? emailData : emailUpdatePayload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json"
                }
            });

            if (emailResponse.status === 200) {
                //enqueueSnackbar("Draft saved", { variant: "info" });
                setReplyEmailId(null);
                fetchEmails();
                setShowReplySection(false);
            }

            if (emailResponse.status !== 200) {
                throw new Error("Failed to create email.");
            }

            const emailId = emailResponse!.data.id;

            // Step 2: Upload Attachments to Azure Blob Storage
            // Step 2: Handle Attachments (upload + link)
            const filesToUpload = selectedFiles.filter(
                file => !filesUploadedToDraft.includes(file.name)
            );

            // Upload new files to Azure Blob Storage
            if (filesToUpload.length > 0) {
                const formData = new FormData();
                formData.append("emailId", emailId);
                filesToUpload.forEach(file => formData.append("attachments", file));

                try {
                    await axiosExt.post(`${API_BASE_URL}/emails/upload-attachments`, formData, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "multipart/form-data",
                        },
                    });

                    // Mark files as uploaded (only if this was a draft save)
                    if (saveOnly) {
                        setFilesUploadedToDraft(prev => [...prev, ...filesToUpload.map(f => f.name)]);
                    }
                } catch (uploadErr) {
                    console.error("Attachment upload failed:", uploadErr);
                    enqueueSnackbar("Failed to upload file attachments", { variant: "error" });
                }
            }

            // Link existing blob attachments to email
            if (selectedBlobAttachments.length > 0) {
                try {
                    await axiosExt.post(`${API_BASE_URL}/emails/add-existing-attachments`, {
                        emailId,
                        attachments: selectedBlobAttachments
                    }, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    });
                } catch (linkErr) {
                    console.error("Failed to link existing blob attachments:", linkErr);
                    enqueueSnackbar("Failed to attach selected files", { variant: "error" });
                }
            }

            //if (selectedFiles.length > 0) {
            //    const formData = new FormData();
            //    formData.append("emailId", emailId);
            //    selectedFiles.forEach(file => {
            //        formData.append("attachments", file);
            //    });

            //    await axiosExt.post(`${API_BASE_URL}/emails/upload-attachments`, formData, {
            //        headers: {
            //            "Authorization": `Bearer ${token}`,
            //            "Content-Type": "multipart/form-data",
            //        },
            //    });
            //    setFilesUploadedToDraft(selectedFiles.map(f => f.name));
            //}

            //if (selectedBlobAttachments.length > 0) {
            //    await axiosExt.post(`${API_BASE_URL}/emails/add-existing-attachments`, {
            //        emailId,
            //        attachments: selectedBlobAttachments
            //    }, {
            //        headers: {
            //            "Authorization": `Bearer ${token}`,
            //            "Content-Type": "application/json",
            //        },
            //    });
            //}

            // Step 3: Send the Email with Attachments

            if (!saveOnly) {
                await axiosExt.post(`${API_BASE_URL}/emails/reply`, { id: emailId, ...emailData }, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                });
                enqueueSnackbar(t("Reply sent successfully!"), { variant: "success" });
            }
            else
                enqueueSnackbar(t("Draft saved"), { variant: "success" });
            
            // Reset fields
            fetchEmails();
            setShowReplySection(false);
            setReplyMessage("");
            setReplyEmailId(null); 
            setDeletedBlobFileUrls([]);
            //setReplyMessage(
            //    `<br />${currentUser?.emailSignature || ''}<br /><br />${(
            //        emails
            //            .sort((a, b) => new Date(b.receivedAt || 0).getTime() - new Date(a.receivedAt || 0).getTime())[0]
            //            ?.content || ''
            //    )}`
            //);
            setSelectedFiles([]);
            setSelectedBlobAttachments([]);
        } catch (error) {
            console.error("Error sending email:", error);
            alert("Failed to send email.");
        } finally {
            setSending(false);
        }
    };

    const handleNewEmail = () => {
        setToRecipients([]);
        setCcRecipients([]);
        setNewToEmail("");
        setNewCcEmail("");
        setReplySubject("");
        setReplyMessage(buildReplyMessage());
        setShowReplySection(true);
        setReplyEditorKey(prev => prev + 1);
        setTimeout(() => replyInputRef.current?.getEditor()?.focus(), 100);
    };

    const handleReplyToSender = async (email: Email) => {
        const sender = extractEmailAddress(email.from || "").trim();
        //const subjectLine = email.subject?.startsWith("Re:") ? email.subject : `Re: ${email.subject}`;
        const rePrefix = t("Re");
        const subjectLine = email.subject?.startsWith(`${rePrefix}:`) ? email.subject : `${rePrefix}: ${email.subject}`;

        setToRecipients([sender]);
        setCcRecipients([]);
        setThreadId(email.threadId);
        setNewToEmail("");
        setNewCcEmail("");
        setReplySubject(subjectLine);

        //setReplyMessage(
        //    buildReplyMessage(
        //        `<b>${t("From")}:</b> ${email.from || ''}<br /><b>${t("To")}:</b> ${email.to || ''}<br /><b>${t("CC")}:</b> ${email.cc || ''}<br /><b>${t("Subject")}:</b> ${email.subject || ''}<br /><br />${email.content || ''}`
        //    )
        //);

        const body = await ensureEmailContent(email);
        setReplyMessage(buildReplyMessageOutlook({ ...email, content: body }));

        setShowReplySection(true);
        setReplyEditorKey(prev => prev + 1);
        setTimeout(() => replyInputRef.current?.getEditor()?.focus(), 100);
    };

    //const handleSaveDraft = async () => {
    //    const token = localStorage.getItem("token");

    //    if (!token) return;

    //    const isEditingDraft = Boolean(replyEmailId); 
    //    const method = isEditingDraft ? "put" : "post";
    //    const url = isEditingDraft
    //        ? `${API_BASE_URL}/emails/draft/${replyEmailId}` // Update existing draft
    //        : `${API_BASE_URL}/emails?orderNo=${selectedOrder.internalNumber}`; // Create new draft

    //    const emailData = {
    //        from: selectedEmail,
    //        to: toRecipients.join(";"),
    //        cc: ccRecipients.join(";"),
    //        bcc: "",
    //        subject: replySubject,
    //        content: replyMessage,
    //        messageId: "",
    //        orderId: selectedOrder.id,
    //        threadId: threadId,
    //        receivedAt: new Date(),
    //        isRead: true,
    //        isDraft: true
    //    };

    //    const emailUpdatePayload = {
    //        subject: replySubject,
    //        content: replyMessage,
    //        to: toRecipients.join(";"),
    //        cc: ccRecipients.join(";"),
    //        bcc: "",
    //        threadId: threadId
    //    };


    //    try {
    //        const response = await axiosExt[method](url, method === "post" ? emailData : emailUpdatePayload, {
    //            headers: {
    //                Authorization: `Bearer ${token}`,
    //                "Content-Type": "application/json"
    //            }
    //        });

    //        if (response.status === 200) {
    //            enqueueSnackbar("Draft saved", { variant: "info" });
    //            setReplyEmailId(null);
    //            fetchEmails();
    //            setShowReplySection(false);
    //        }
    //    } catch (error) {
    //        console.error("Error saving draft:", error);
    //        enqueueSnackbar("Failed to save draft", { variant: "error" });
    //    }
    //};


    const handleEditDraft = async (email: Email) => {
        setReplyEmailId(email.id);
        setReplySubject(email.subject ?? "");
        // Try from cache, otherwise fetch
        let body = emailContents[email.id] ?? email.content ?? "";
        if (!body) {
            body = await fetchEmailContent(email.id);
        }
        setReplyMessage(body);
        setToRecipients((email.to?.split(";") || []).map(e => e.trim()));
        setCcRecipients((email.cc?.split(";") || []).map(e => e.trim()));
        setSelectedFiles([]); // ensure clean state for local uploads
        setSelectedBlobAttachments(
            (email.attachments || []).map(a => ({
                fileName: a.fileName,
                fileUrl: a.fileUrl,
            }))
        );
        setThreadId(email.threadId ?? "");
        setShowReplySection(true);
        setReplyEditorKey(prev => prev + 1);
    };
        

    const handleDeleteDraft = async (id: string) => {
        const token = localStorage.getItem("token");
        await axiosExt.delete(`${API_BASE_URL}/emails/draft/${id}`, {
            headers: { Authorization: `Bearer ${token}` }
        });
        fetchEmails();
    };



    const generateContactTabs = () => {
        const externalContacts = new Set<string>();

        emails.forEach(email => {
            const allFields = [
                email.from,
                ...(email.to?.split(";") || []),
                ...(email.cc?.split(";") || []),
                ...(email.bcc?.split(";") || [])
            ]
                .map(addr => addr.trim())
                .filter(addr => addr !== "")
                .map(addr => extractEmailAddress(addr));

            const addressesSet = new Set(allFields);

            const isInternal = (address: string) => {
                const matchingUser = users.find(u =>
                    u.email && u.email.trim().toLowerCase() === address
                );
                return matchingUser && (matchingUser.role.toLowerCase() === "admin" || matchingUser.role.toLowerCase() === "support");
            };

            const isCustomer = (address: string) => {
                const normalized = address.trim().toLowerCase();
                return contacts.some(contact => contact.email.trim().toLowerCase() === normalized);
            };

            const allInternalOrCustomer = Array.from(addressesSet).every(address =>
                isInternal(address) || isCustomer(address)
            );

            if (allInternalOrCustomer) {
                // Email is purely internal or customer -> skip
                return;
            }

            // Otherwise, collect external addresses
            addressesSet.forEach(address => {
                if (!isInternal(address) && !isCustomer(address)) {
                    externalContacts.add(address);
                }
            });
        });

        return Array.from(externalContacts).map(contactEmail => (
            <Tab
                key={contactEmail}
                label={getDisplayName(contactEmail, contacts)}
                value={contactEmail}
            />
        ));
    };


    /*const filterEmails = (users: User[]) => {
        if (selectedTab === "All") {
            return emails;
        }

        if (selectedTab === "Customer") {
            return emails.filter(email => {
                const allFields = [email.from, ...(email.to?.split(";") || []), ...(email.cc?.split(";") || []), ...(email.bcc?.split(";") || [])];
                return allFields.some(address =>
                    contacts.some(contact => contact.email.toLowerCase() === address.trim().toLowerCase())
                );
            });
        }

        if (selectedTab === "Internal") {
            return emails.filter(email => {
                const allFields = [
                    email.from,
                    ...(email.to?.split(";") || []),
                    ...(email.cc?.split(";") || []),
                    ...(email.bcc?.split(";") || [])
                ].flatMap(addr =>
                    addr.trim() !== "" ? [extractEmailAddress(addr.trim())] : []
                );

                return allFields.every(address => {
                    const matchingUser = users.find(u =>
                        u.email && u.email.trim() !== "" && u.email.toLowerCase() === address
                    );
                    return matchingUser && (matchingUser.role.toLowerCase() === "admin" || matchingUser.role.toLowerCase() === "support");
                });
            });
        }


        // Dynamic contact tab
        return emails.filter(email => {
            const allFields = [
                email.from,
                ...(email.to?.split(";") || []),
                ...(email.cc?.split(";") || []),
                ...(email.bcc?.split(";") || [])
            ]
                .map(addr => addr.trim())
                .filter(addr => addr !== "")
                .map(addr => extractEmailAddress(addr));

            const addressesSet = new Set(allFields);

            const isInternal = (address: string) => {
                const matchingUser = users.find(u => u.email.toLowerCase() === address.toLowerCase());
                return matchingUser !== undefined;
            };

            const isCustomer = (address: string) => {
                return contacts.some(contact => contact.email.toLowerCase() === address);
            };

            const allInternalOrCustomer = Array.from(addressesSet).every(address =>
                isInternal(address) || isCustomer(address)
            );

            if (allInternalOrCustomer) {
                // Only internal or customer → ignore
                return false;
            }

            // Now check if selectedTab matches any email
            return addressesSet.has(selectedTab);
        });

    };*/

    /*const filterEmails = (users: User[]) => {
        let emailsFilteredByTab: Email[] = [];

        if (selectedTab === "All") {
            emailsFilteredByTab = emails;
        } else if (selectedTab === "Customer") {
            emailsFilteredByTab = emails.filter(email => {
                const allFields = [email.from, ...(email.to?.split(";") || []), ...(email.cc?.split(";") || []), ...(email.bcc?.split(";") || [])];
                return allFields.some(address =>
                    contacts.some(contact => contact.email.toLowerCase() === address.trim().toLowerCase())
                );
            });
        } else if (selectedTab === "Internal") {
            emailsFilteredByTab = emails.filter(email => {
                const allFields = [
                    email.from,
                    ...(email.to?.split(";") || []),
                    ...(email.cc?.split(";") || []),
                    ...(email.bcc?.split(";") || [])
                ].flatMap(addr =>
                    addr.trim() !== "" ? [extractEmailAddress(addr.trim())] : []
                );

                return allFields.every(address => {
                    const matchingUser = users.find(u =>
                        u.email && u.email.trim() !== "" && u.email.toLowerCase() === address
                    );
                    return matchingUser && (matchingUser.role.toLowerCase() === "admin" || matchingUser.role.toLowerCase() === "support");
                });
            });
        } else {
            // Specific external contact tab
            emailsFilteredByTab = emails.filter(email => {
                const allFields = [
                    email.from,
                    ...(email.to?.split(";") || []),
                    ...(email.cc?.split(";") || []),
                    ...(email.bcc?.split(";") || [])
                ]
                    .map(addr => addr.trim())
                    .filter(addr => addr !== "")
                    .map(addr => extractEmailAddress(addr));

                const addressesSet = new Set(allFields);

                const isInternal = (address: string) => {
                    const matchingUser = users.find(u => u.email.toLowerCase() === address.toLowerCase());
                    return matchingUser !== undefined;
                };

                const isCustomer = (address: string) => {
                    return contacts.some(contact => contact.email.toLowerCase() === address);
                };

                const allInternalOrCustomer = Array.from(addressesSet).every(address =>
                    isInternal(address) || isCustomer(address)
                );

                if (allInternalOrCustomer) return false;

                return addressesSet.has(selectedTab);
            });
        }

        // Apply Inbox / Sent / Both filter
        if (emailViewFilter === "Inbox") {
            emailsFilteredByTab = emailsFilteredByTab.filter(email => email.incoming === true);
        } else if (emailViewFilter === "Sent") {
            emailsFilteredByTab = emailsFilteredByTab.filter(email => email.incoming === false);
        }

        return emailsFilteredByTab;
    };*/

    const handleAddContactClick = (email: string) => {
        setPendingEmail(email); // store in state
        setAddContactDialogOpen(true); // open dialog
    };

    const filterEmails = (users: User[]) => {
        let emailsFilteredByTab: Email[] = [];

        switch (selectedTab) {
            case "All":
                emailsFilteredByTab = emails;
                break;

            case "Customer":
                emailsFilteredByTab = emails.filter(email => {
                    const allFields = [email.from, ...(email.to?.split(";") || []), ...(email.cc?.split(";") || []), ...(email.bcc?.split(";") || [])];
                    return allFields.some(address =>
                        contacts.some(contact => contact.email.toLowerCase() === address.trim().toLowerCase())
                    );
                });
                break;

            case "Internal":
                emailsFilteredByTab = emails.filter(email => {
                    const allFields = [
                        email.from,
                        ...(email.to?.split(";") || []),
                        ...(email.cc?.split(";") || []),
                        ...(email.bcc?.split(";") || [])
                    ]
                        .map(addr => extractEmailAddress(addr.trim()))
                        .filter(Boolean);

                    return allFields.every(address =>
                        users.some(u =>
                            u.email?.trim().toLowerCase() === address &&
                            ["admin", "support"].includes(u.role.toLowerCase())
                        )
                    );
                });
                break;

            case "Customs":
                emailsFilteredByTab = emails.filter(email => email.emailType === EmailTypeList.Customs);
                break;

            default:
                // Specific external contact
                emailsFilteredByTab = emails.filter(email => {
                    const allFields = [
                        email.from,
                        ...(email.to?.split(";") || []),
                        ...(email.cc?.split(";") || []),
                        ...(email.bcc?.split(";") || [])
                    ]
                        .map(addr => extractEmailAddress(addr.trim()))
                        .filter(Boolean);

                    const addressSet = new Set(allFields);

                    const isInternal = (email: string) =>
                        users.some(u => u.email?.toLowerCase() === email.toLowerCase());

                    const isCustomer = (email: string) =>
                        contacts.some(c => c.email.toLowerCase() === email);

                    const allInternalOrCustomer = allFields.every(addr =>
                        isInternal(addr) || isCustomer(addr)
                    );

                    if (allInternalOrCustomer) return false;

                    return addressSet.has(selectedTab);
                });
                break;
        }

        let filteredEmails = emailsFilteredByTab;
        switch (readStatusFilter.toLowerCase()) {
            case "read":
                filteredEmails = emailsFilteredByTab.filter(e => e.isRead === true || recentlyMarkedAsUnread.includes(e.id));
                break;
            case "unread":
                filteredEmails = emailsFilteredByTab.filter(e => e.isRead === false || recentlyMarkedAsRead.includes(e.id));
                break;
            default:
                filteredEmails= emailsFilteredByTab;
        }
        // Filter by view type
        switch (emailViewFilter.toLowerCase()) {
            case "inbox":
                return filteredEmails.filter(e => e.incoming === true);
            case "sent":
                return filteredEmails.filter(e => e.incoming === false);
            default:
                return filteredEmails;
        }

    };


    /*const filtered = [...filterEmails(users)].sort(
        (a, b) => new Date(b.receivedAt || 0).getTime() - new Date(a.receivedAt || 0).getTime()
    );*/


    const filteredAndSortedEmails = useMemo(() => {
        return [...filterEmails(users)].sort(
            (a, b) => new Date(b.receivedAt || 0).getTime() - new Date(a.receivedAt || 0).getTime()
        );
    }, [emails, selectedTab, emailViewFilter, readStatusFilter, users, contacts]);


    /*const filteredAttachments = filterEmails(users)
        .flatMap(email =>
            (email.attachments || [])
                .filter(att => {
                    //const cidPattern = new RegExp(`cid:.*${att.fileName}`, "i");
                    const cidPattern = new RegExp(`cid:.*${escapeRegExp(att.fileName)}`, "i");
                    return !cidPattern.test(email.content || "");
                })
                .map(att => ({
                    date: email.receivedAt,
                    from: email.from,
                    fileName: att.fileName,
                    fileUrl: att.fileUrl
                }))
    );*/

    const filteredAttachments = useMemo(() => {
        return filteredAndSortedEmails.flatMap(email => (
            (email.attachments || []).filter(att => {
                const cidPattern = new RegExp(`cid:.*${escapeRegExp(att.fileName)}`, "i");
                return !cidPattern.test(email.content || "");
            }).map(att => ({
                id:att.id,
                date: email.receivedAt,
                from: email.from,
                fileName: att.fileName,
                fileUrl: att.fileUrl
            }))
        ));
    }, [filteredAndSortedEmails]);

    const openEditorWithReplyAll = () => {
        setShowReplySection(true);
        setReplyEditorKey(prev => prev + 1); // force re-render
        setTimeout(() => {
            const filtered = [...filterEmails(users)].sort(
                (a, b) => new Date(b.receivedAt || 0).getTime() - new Date(a.receivedAt || 0).getTime()
            );
            const firstEmail = filtered[0];
            if (firstEmail) {
                handleReplyAll(firstEmail);
                setTimeout(() => {
                    replyInputRef.current?.getEditor()?.root?.dispatchEvent(new Event("input")); // force reflow
                    replyInputRef.current?.getEditor()?.focus();
                }, 30); // after Quill finishes rendering
            }
        }, 30); // give Quill enough time to mount
    };

    
    return (
         <>
            <Box sx={{ paddingLeft: "20px", maxHeight: "100vh" }} marginTop="0px">
             {/* Reply Section */}
             <Box sx={{ display: "flex", alignItems: "center", gap: 1 }} >
                    {headerStart}
                    <Typography variant="h6">{currentOrderNumberEmailsLoaded}</Typography>
                <Button
                  variant="contained"
                        color={"primary"}

                        onClick={openEditorWithReplyAll}
                    >
                  <ReplyAllIcon fontSize="small" sx={{ mr: 0 }} />
                  {t("Reply All")}
                 </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        const filteredAndSortedEmails = [...filterEmails(users)].sort(
                            (a, b) => new Date(b.receivedAt || 0).getTime() - new Date(a.receivedAt || 0).getTime()
                        );
                        const firstEmailInTab = filteredAndSortedEmails[0];
                        if (firstEmailInTab) handleReplyToSender(firstEmailInTab);
                    }}
                    disabled={emails.length === 0}
                    >
                    <ReplyIcon fontSize="small" sx={{ mr: 0 }} />
                    {t("Reply")}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        const filteredAndSortedEmails = [...filterEmails(users)].sort(
                            (a, b) => new Date(b.receivedAt || 0).getTime() - new Date(a.receivedAt || 0).getTime()
                        );
                        const firstEmailInTab = filteredAndSortedEmails[0];
                        if (firstEmailInTab) handleForwardEmail(firstEmailInTab);
                    }}
                    disabled={emails.length === 0}
                >
                    <ForwardIcon fontSize="small" sx={{ mr: 0 }} />
                    {t("Forward")}
                </Button>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={handleNewEmail}
                    >
                    <NewIcon fontSize="small" sx={{ mr: 0, color:"white" }} />
                    {t("New")}
                </Button>
                    <IconButton onClick={() => setShowAttachmentDialog(true)} title="Show Attachments" sx={{ mr: 0, ml:0, gl:0}} >
                     <AttachFileIcon />
                 </IconButton>
             </Box>
             <Box sx={{ borderBottom: 1, borderColor: 'divider', marginBottom: "4px" }}>
                 <Tabs
                     value={selectedTab}
                     onChange={(_, newValue) => setSelectedTab(newValue)}
                     variant="scrollable"
                     scrollButtons="auto"
                 >
                     <Tab label={t("All")} value="All" />
                     <Tab label={t("Customer")} value="Customer" />
                     <Tab label={t("Internal")} value="Internal" />
                        <Tab
                            label={t("Customs")}
                            value="Customs"
                            sx={{
                                backgroundColor: CUSTOMS_EMAIL_COLOR
                            }}
                        />
                     {generateContactTabs()} 
                 </Tabs>
             </Box>
             {showReplySection && (
                 <>
                     <Box sx={{ paddingBottom: "10px"}}>
                         <Grid container spacing={1} rowSpacing={0.5} alignItems="center">
                             {/* Subject */}
                             <Grid item xs={2} sx={{ marginBottom: "0px", marginTop: "0px" }}>
                                 <Box display="flex" alignItems="center" gap={1}>
                                     <Typography variant="body2">{t("Subject")}:</Typography>
                                 </Box>
                             </Grid>
                             <Grid item xs={10} sx={{ marginBottom: "0px", marginTop: "0px" }}>
                                 <TextField 
                                     fullWidth
                                     onChange={(e) => setReplySubject(e.target.value)}
                                     value={replySubject}
                                 />
                             </Grid>

                             {/* From row */}
                             {emailOptions.length > 1 && (
                                 <>
                                 <Grid item xs={2} sx={{ marginBottom: "0px", marginTop: "0px" }}>
                                     <Box display="flex" alignItems="center" gap={1}>
                                         <Typography variant="body2">{t("From")}:</Typography>
                                     </Box>
                                 </Grid>
                                 <Grid item xs={10} sx={{ marginBottom: "0px", marginTop: "0px" }}>
                                     <Autocomplete
                                         fullWidth
                                         options={emailOptions}
                                         value={selectedEmail}
                                         onChange={(_, newValue) => {
                                             setSelectedEmail(newValue);
                                         }}
                                         renderInput={(params) => (
                                             <TextField {...params} label="From Email" />
                                         )}
                                     />
                                 </Grid>
                                 </>
                             )}

                             {/* To */}
                             <Grid item xs={2} sx={{ marginBottom: "0px", marginTop: "0px" }}>
                                 <Box display="flex" alignItems="center" gap={1}>
                                     <Typography variant="body2">{t("To")}:</Typography>
                                     <Button
                                         variant="outlined"
                                         size="small"
                                         onClick={() => setShowNewToField((prev) => !prev)}
                                     >
                                         {showNewToField ? "-" : "+"}
                                     </Button>
                                 </Box>
                             </Grid>
                             <Grid item xs={10} sx={{ marginBottom: "0px", marginTop: "0px" }}>
                                 <Autocomplete
                                     multiple
                                        options={[
                                            ...contacts,
                                            ...(unassignedContacts ?? [])
                                        ]
                                            .map(contact => contact.email)
                                            .filter(email => email.trim() !== '')
                                        }
                                     value={toRecipients.filter(email => email.trim() !== '')}  
                                     onChange={(_, newValue) => setToRecipients(newValue.map(email => email.trim()))}
                                     getOptionLabel={(email) => {
                                         const contact = contacts.find(contact => contact.email === email);
                                         if (contact) {
                                             return `${contact.firstName} ${contact.lastName} <${email}>`;  // Show full name and email in the dropdown
                                         }
                                         return email;  // Show just email if contact is not found
                                     }}
                                     renderTags={(value, getTagProps) =>
                                         value.map((option, index) => {
                                             const contact = contacts.find(contact => contact.email === option);
                                             const label = contact
                                                 ? `${contact.firstName} ${contact.lastName} <${option}>`
                                                 : `<${option}>`; // ✅ Always show email
                                             return <Chip label={label} {...getTagProps({ index })} />;
                                         })
                                     }
                                     renderInput={(params) => {
                                         const displayedRecipients = toRecipients.map(email => {
                                             const contact = contacts.find(contact => contact.email === email);
                                             if (contact) {
                                                 return `${contact.firstName} ${contact.lastName} <${email}>`;  // Display full name with email in input
                                             }
                                             return email;  // Display just the email if no contact is found
                                         }).join(', ');
                                         return <TextField {...params} placeholder="Select emails or click + to add new" value={displayedRecipients} />;
                                     }}
                                     fullWidth
                                 />
                             </Grid>



                             {/* New Email Input Field - Aligns Exactly Below */}
                             {showNewToField && (
                                 <>
                                     <Grid item xs={2} /> {/* Empty space for alignment */}
                                     <Grid item xs={10}>
                                         <TextField
                                             fullWidth
                                             placeholder={t("Type new addresses separated by ;")}
                                             value={newToEmail}
                                             onChange={(e) => setNewToEmail(e.target.value)}
                                         />
                                     </Grid>
                                 </>
                             )}

                             {/* Cc */}
                             <Grid item xs={2} sx={{ marginBottom: "0px", marginTop: "0px" }}>
                                 <Box display="flex" alignItems="center" gap={1}>
                                     <Typography variant="body2">{t("CC")}:</Typography>
                                     <Button
                                         variant="outlined"
                                         size="small"
                                         onClick={() => setShowNewCcField((prev) => !prev)}
                                     >
                                         {showNewCcField ? "-" : "+"}
                                     </Button>
                                 </Box>
                             </Grid>
                             <Grid item xs={10} sx={{ marginBottom: "0px", marginTop: "0px" }}>
                                 <Autocomplete
                                     multiple
                                     options={[
                                            ...contacts,
                                            ...(unassignedContacts ?? [])
                                        ]
                                            .map(contact => contact.email)
                                            .filter(email => email.trim() !== '')
                                        }
                                     value={ccRecipients.filter(email => email.trim() !== '')}
                                     onChange={(_, newValue) => setCcRecipients(newValue.map(email => email.trim()))}
                                     getOptionLabel={(email) => {
                                         const contact = contacts.find(contact => contact.email === email);
                                         if (contact) {
                                             return `${contact.firstName} ${contact.lastName} <${email}>`;  // Show full name and email in the dropdown
                                         }
                                         const unassignedContact = unassignedContacts?.find(contact => contact.email === email);
                                         if (unassignedContact) {
                                             return `${unassignedContact.firstName} ${unassignedContact.lastName} <${email}>`;  // Show full name and email in the dropdown
                                         }
                                         return email;  // Show just email if contact is not found
                                     }}
                                     renderTags={(value, getTagProps) =>
                                         value.map((option, index) => {
                                             let contact = contacts.find(contact => contact.email === option);
                                             if (!contact) {    
                                                 contact = unassignedContacts?.find(contact => contact.email === option);
                                             }
                                             const label = contact
                                                 ? `${contact.firstName} ${contact.lastName} <${option}>`  // Show full name and email in selected tags
                                                 : option;  // Show just the email if no contact is found
                                             //return <Chip key={option} label={label} {...getTagProps({ index })} />;
                                             return <Chip label={label} {...getTagProps({ index })} />;
                                         })
                                     }
                                     renderInput={(params) => {
                                         const displayedRecipients = ccRecipients.map(email => {
                                             let contact = contacts.find(contact => contact.email === email);
                                             if (!contact) {
                                                 contact = unassignedContacts?.find(contact => contact.email === email);
                                             }
                                             if (contact) {
                                                 return `${contact.firstName} ${contact.lastName} <${email}>`;  // Display full name with email in input
                                             }
                                             return email;  // Display just the email if no contact is found
                                         }).join(', ');
                                         return <TextField {...params} placeholder={t("Select emails or click + to add new")} value={displayedRecipients} />;
                                     }}
                                     fullWidth
                                 />
                             </Grid>

                             {/* New Email Input Field - Aligns Exactly Below */}
                             {showNewCcField && (
                                 <>
                                     <Grid item xs={2} /> {/* Empty space for alignment */}
                                     <Grid item xs={10}>
                                         <TextField
                                             fullWidth
                                             placeholder={t("Type new addresses separated by ;")}
                                             value={newCcEmail}
                                             onChange={(e) => setNewCcEmail(e.target.value)}
                                         />
                                     </Grid>
                                 </>
                             )}
                         </Grid>
                     </Box>
                     <Box>
                         <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                             <Box sx={{ display: "flex", gap: 1 }}>
                                 <Button
                                     variant="contained"
                                     color="primary"
                                     onClick={() => handleSendReply(false)}
                                     disabled={!hasUserTyped || sending}
                                 >
                                     {sending ? t("Sending...") : t("Send")}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => handleSendReply(true)}
                                    >
                                        {t("Save as Draft")}
                                    </Button>
                                 <Button
                                     variant="contained"
                                     color="error"
                                     onClick={() => {
                                            handleShowReplyClick(false);
                                            setReplyEmailId(null); // ✅ Reset
                                        }}

                                 >
                                     {t("Cancel")}
                                    </Button>


                             </Box>
                             <Autocomplete
                                 disablePortal
                                 size="small"
                                 options={templates}
                                 getOptionLabel={(option) => `${option.name} (${option.language})`}
                                 onChange={(_, selected) => {
                                     if (selected && selectedOrder) {
                                         //const updatedOrder = await fetchOrderForTemplate(selectedOrder.id);
                                         //if (!updatedOrder) return;
                                         const populated = populateTemplate(selected.message, selectedOrder);
                                         setReplyMessage(prev => `${populated}<br />${prev}`);
                                     }
                                 }}
                                 renderInput={(params) => <TextField {...params} label="Templates" />}
                                 sx={{ width: 250 }}
                             />
                         </Box>
                         <Box sx={{ marginTop: "5px", marginBottom:"5px" }}>
                                 <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
                                     <Typography variant="subtitle1">{t("Attachments")}:</Typography>
                                     <input
                                         type="file"
                                         multiple
                                         onChange={handleFileChange}
                                         ref={fileInputRef}
                                         style={{ display: "none" }}
                                     />
                                     <Button
                                         variant="contained"
                                         onClick={() => fileInputRef.current?.click()}
                                     >
                                         {t("Upload")}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => setShowAttachmentDialog(true)} title="Select Attachments"
                                    >
                                        {t("Select")}
                                    </Button>
                                     {selectedFiles.map((file, index) => (
                                         <Box
                                             key={index}
                                             sx={{
                                                 display: "flex",
                                                 alignItems: "center",
                                                 border: "1px solid #ccc",
                                                 borderRadius: "4px",
                                                 padding: "6px 6px",
                                             }}
                                         >
                                             <Typography variant="body2">{file.name}</Typography>
                                             <IconButton
                                                 color="error"
                                                 size="small"
                                                 onClick={() => handleDeleteAttachment(file.name, "local")}
                                                 sx={{ marginLeft: "5px" }}
                                             >
                                                 <DeleteIcon fontSize="small" />
                                             </IconButton>
                                         </Box>
                                     ))}
                                    {/* Show previously attached blob files */}
                                    {selectedBlobAttachments.map((file, index) => (
                                        <Box
                                            key={`blob-${index}`}
                                            sx={{ display: "flex", alignItems: "center", border: "1px solid #ccc", borderRadius: "4px", padding: "6px 6px" }}
                                        >
                                            <Typography variant="body2">{file.fileName}</Typography>
                                            <IconButton
                                                color="error"
                                                size="small"
                                                onClick={() => handleDeleteAttachment(file.fileName, "blob")}
                                                sx={{ marginLeft: "5px" }}
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Box>
                                    ))}
                                 </Box>
                         </Box>
                         {/*<Box*/}
                         {/*    style={{*/}
                         {/*        resize: "vertical",*/}
                         {/*        overflow: "auto",*/}
                         {/*        minHeight: "300px",*/}
                         {/*        maxHeight: "50vh",*/}
                         {/*        border: "1px solid #ccc",*/}
                         {/*        borderRadius: "4px",*/}
                         {/*        padding: "0",*/}
                         {/*    }}*/}
                         {/*>*/}

                         {/*       <CustomQuillEditor*/}
                         {/*           value={replyMessage}*/}
                         {/*           onChange={handleReplyChange}*/}
                         {/*           ref={replyInputRef}*/}
                         {/*           style={{ height: "100%" }}*/}
                         {/*           onFieldValueSelected={onFieldValueSelected}*/}
                         {/*       />*/}
                         {/*</Box>*/}
                            <Box
                                sx={{
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    minHeight: "300px",
                                    maxHeight: "600px",
                                    overflow: "hidden",
                                    display: "flex",         
                                    flexDirection: "column", 
                                }}
                            >
                                <CustomQuillEditor
                                    key={replyEditorKey}
                                    value={replyMessage}
                                    onChange={handleReplyChange}
                                    ref={replyInputRef}
                                    onFieldValueSelected={onFieldValueSelected}
                                    style={{ height: "100%" }} // Let parent Box control size
                                    isReadOnlyMode={false}
                                />
                            </Box>
                       
                         <Box sx={{ display: "flex", gap: 1, marginTop:"5px" }}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => handleSendReply()}
                                disabled={!hasUserTyped || sending}
                            >
                                {sending ? t("Sending...") : t("Send")}
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => handleSendReply(true)}
                            >
                                {t("Save as Draft")}
                            </Button>
                             <Button
                                 variant="contained"
                                 color="error"
                                 onClick={() => handleShowReplyClick(false)}
                             >
                                 {t("Cancel")}
                             </Button>

                         </Box>
                     </Box>
                 </>
                )}

                <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 0, mt: 0, pt:0, pb:0 }}>
                    {/* Inbox/Sent Filter */}
                    <Box>
                        <RadioGroup
                            row
                            value={emailViewFilter}
                            onChange={handleEmailViewChange}
                            name="email-view-filter"
                        >
                            <FormControlLabel value="InboxAndSent" control={<Radio />} label={t("All")} />
                            <FormControlLabel value="Inbox" control={<Radio />} label={t("Inbox")} />
                            <FormControlLabel value="Sent" control={<Radio />} label={t("Sent")} />
                        </RadioGroup>
                    </Box>

                    {/* Read/Unread/All Filter */}
                    <Box>
                        <RadioGroup
                            row
                            value={readStatusFilter}
                            onChange={handleReadStatusFilterChange}
                            name="read-status-filter"
                        >
                            <FormControlLabel value="all" control={<Radio />} label={t("All")} />
                            <FormControlLabel value="unread" control={<Radio />} label={t("Unread")} />
                            <FormControlLabel value="read" control={<Radio />} label={t("Read")} />
                        </RadioGroup>
                    </Box>
                </Box>


                <Box id="email-container" sx={{
                    mb: 0, ml: 0, pl:0, mt:0
                }}>
                 <List>
                        {filteredAndSortedEmails.length > 0 ? (
                            <>
                                {[...filteredAndSortedEmails]
                                    .map((email) => {
                                        const isRead = email.isRead || recentlyMarkedAsRead.includes(email.id); // or `!!email.readAt`, adjust to your field
                                        //const isRead = email.isRead === 1;

                                        const emailTextStyle = {
                                            fontWeight: isRead ? "normal" : "bold",
                                            color: isRead ? "inherit" : "var(--color-blue)",
                                        };
                                        return (
                                            <React.Fragment key={email.id}>

                                                <ListItem sx={{ display: "flex", flexDirection: "column", width: "100%",ml:"0", pl:"0" }}>
                                                    {/* Metadata Section */}
                                                    <Box
                                                        sx={{
                                                            backgroundColor: email.isDraft ? "lightyellow" : 
                                                                email.emailType === EmailTypeList.Customs
                                                                    ? CUSTOMS_EMAIL_COLOR
                                                                    : (email.incoming ? "lightgray" : "lightblue"),
                                                            padding: 1,
                                                            borderRadius: 1,
                                                            width: "100%",
                                                            position: "relative",
                                                            mb:0,ml:0
                                                        }}
                                                    >
                                                        {/* Row 1: From and Date */}
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                width: "100%",
                                                                cursor: "pointer",
                                                                mt: 0, 
                                                            }}

                                                            onClick={async () => {
                                                                const willExpand = !expandedEmails[email.id];
                                                                setExpandedEmails((prev) => ({
                                                                    ...prev,
                                                                    [email.id]: willExpand,
                                                                }));

                                                                if (willExpand) {
                                                                    await fetchEmailContent(email.id);
                                                                }

                                                                if (!email.isRead && (selectedOrder.assignedToUserId?.trim().toLowerCase() === currentUser.id?.trim().toLowerCase()) ) {
                                                                    await markEmailAsRead(email.id);
                                                                }
                                                            }}
                                                        >
                                                            {/* From */}
                                                            <Box sx={{ width: "75%", display: "flex", alignItems: "center", gap: 1, fontWeight: "bold" }}>
                                                                <Typography variant="body2" sx={{ ...emailTextStyle }}>
                                                                    {t("From")}:
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ ...emailTextStyle }}>{getDisplayName(email.from, contacts)}</Typography>
                                                                <Box sx={{ ml: 1, gap:1 }}>
                                                                    {expandedEmails[email.id] ? "▼" : "▶"}
                                                                </Box>
                                                                {email.isDraft && (
                                                                    <>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => handleEditDraft(email)}
                                                                            title="Edit Draft"
                                                                        >
                                                                            <EditIcon fontSize="small" />
                                                                        </IconButton>
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => setDraftToDelete(email)}
                                                                            title={t("Delete")}
                                                                        >
                                                                            <DeleteIcon fontSize="small" />
                                                                        </IconButton>

                                                                    </>
                                                                )}

                                                                {!email.isDraft && (
                                                                    <>
                                                                        {/* Right: Reply Icons */}
                                                                        <Box sx={{ display: "flex", gap: 0.5 }}>
                                                                            <IconButton
                                                                                size="small"
                                                                                color="default"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleReplyToSender(email);
                                                                                }}
                                                                                title={t("Reply")}
                                                                            >
                                                                                <ReplyIcon fontSize="small" />
                                                                            </IconButton>
                                                                            <IconButton
                                                                                size="small"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleReplyAll(email);
                                                                                }}
                                                                                title={t("Reply All")}
                                                                            >
                                                                                <ReplyAllIcon fontSize="small" />
                                                                            </IconButton>
                                                                            <IconButton
                                                                                size="small"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleForwardEmail(email);
                                                                                }}
                                                                                title={t("Forward")}
                                                                            >
                                                                                <ForwardIcon fontSize="small" />
                                                                            </IconButton>
                                                                            <IconButton
                                                                                size="small"
                                                                                onClick={async (e) => {
                                                                                    e.stopPropagation(); // Prevent expanding on click

                                                                                    if (email.isRead) {
                                                                                        await markEmailAsUnread(email.id);
                                                                                        email.isRead = false; // Update local state to reflect unread status
                                                                                    } else {
                                                                                        await markEmailAsRead(email.id);
                                                                                        email.isRead = true; // Update local state to reflect read status
                                                                                    }
                                                                                }}
                                                                                title={email.isRead ? t("Mark as Unread") : t("Mark as Read")}
                                                                            >
                                                                                {email.isRead ? <MarkEmailUnreadIcon fontSize="small" /> : <MarkEmailReadIcon fontSize="small" />}
                                                                            </IconButton>

                                                                        </Box>
                                                                    </>
                                                                )}                                         

                                                            </Box>

                                                            {/* Date */}
                                                            <Box
                                                                sx={{
                                                                    width: "25%",
                                                                    display: "flex",
                                                                    justifyContent: "flex-end", 
                                                                    alignItems: "center",       
                                                                    gap: 0.5,
                                                                }}
                                                            >
                                                                <>
                                                                    {!customers.some(c => c.email?.toLowerCase() === email.from?.toLowerCase()) && (
                                                                        <IconButton
                                                                            size="small"
                                                                            onClick={() => handleAddCustomerClick(email.from)}
                                                                            title={t("Add customer")}
                                                                        >
                                                                            <AddBusinessIcon fontSize="small" />
                                                                        </IconButton>
                                                                    )}


                                                                    {!contacts.some(c => c.email?.toLowerCase() === email.from?.toLowerCase()) && !(email.emailType === EmailTypeList.Customs) && (
                                                                        <>
                                                                            <IconButton
                                                                                size="small"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    handleAddContactClick(email.from)
                                                                                }}
                                                                                title={t("Add contact")}
                                                                            >
                                                                                <AddPersonIcon fontSize="small" />
                                                                            </IconButton>
                                                                            <IconButton
                                                                                size="small"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setIgnoreEmail(email.from);
                                                                                    setShowIgnoreDialog(true);
                                                                                }}
                                                                                title={t("Ignore Emails and Domains")}
                                                                            >
                                                                                <BlockIcon fontSize="small" />
                                                                            </IconButton>
                                                                        </>
                                                                    )}
                                                                </>   

                                                                
                                                            </Box>
                                                        </Box>

                                                        {/* Row 2: Date */}
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                width: "100%",
                                                                mt: 0
                                                            }}
                                                        >
                                                            {/* Date */}
                                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                                <Typography variant="body2" sx={{ ...emailTextStyle }}>
                                                                    {t("Date")}:
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ ...emailTextStyle }}>
                                                                    {email.receivedAt
                                                                        ? new Intl.DateTimeFormat(undefined, {
                                                                            dateStyle: "medium",
                                                                            timeStyle: "short",
                                                                            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                                                                        }).format(new Date(email.receivedAt + "Z"))
                                                                        : ""}
                                                                </Typography>
 
                                                            </Box>
                                                        </Box>

                                                        {/* Row 3: Subject */}
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                width: "100%",
                                                                mt:"5px"
                                                            }}
                                                        >
                                                            {/* Subject */}
                                                            <Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: 1 }}>
                                                                <Typography variant="body2" sx={{ ...emailTextStyle }}>
                                                                    {t("Subject")}:
                                                                </Typography>
                                                                <Typography variant="body2" sx={{ ...emailTextStyle }}>
                                                                    {email.subject}
                                                                </Typography>
                                                            </Box>
                                                        </Box>


                                                        {/* Row 2: From and To */}
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                width: "100%",
                                                                mt: "5px"
                                                            }}
                                                        >
                                                            {/* To */}
                                                            <Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: 1 }}>
                                                                <Typography variant="body2">
                                                                    {t("To")}:
                                                                </Typography>
                                                                <Typography variant="body2">{formatEmails(email.to, contacts)}</Typography>
                                                            </Box>
                                                        </Box>

                                                        {/* Row 3: CC */}
                                                        {(email.cc) && (
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    width: "100%",
                                                                }}
                                                            >
                                                                {/* CC */}
                                                                <Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: 1 }}>
                                                                    {email.cc && (
                                                                        <>
                                                                            <Typography variant="body2">
                                                                                {t("CC")}:
                                                                            </Typography>
                                                                            <Typography variant="body2">{formatEmails(email.cc, contacts)}</Typography>
                                                                        </>
                                                                    )}
                                                                </Box>
                                                            </Box>
                                                        )}

                                                        {/* Row 4 : BCC */}
                                                        {(email.bcc) && (
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    width: "100%",
                                                                    mb: 1,
                                                                }}
                                                            >
                                                                {/* BCC */}
                                                                <Box sx={{ width: "100%", display: "flex", alignItems: "center", gap: 1 }}>
                                                                    {email.bcc && (
                                                                        <>
                                                                            <Typography variant="body2" >
                                                                                {t("BCC")}:
                                                                            </Typography>
                                                                            <Typography variant="body2">{formatEmails(email.bcc, contacts)}</Typography>
                                                                        </>
                                                                    )}
                                                                </Box>
                                                            </Box>
                                                        )}



                                                        {/* Attachments if any */}
                                                        {email.attachments && email.attachments.length > 0 && (
                                                            <Box sx={{ display: "flex", width: "100%", alignItems: "center", gap: 1, flexWrap: "wrap", mt: 1 }}>
                                                                {email.attachments
                                                                    .filter((attachment) => {
                                                                        const fileName = attachment.fileName;
                                                                        //const cidPattern = new RegExp(`cid:.*${fileName}`, "i");
                                                                        const cidPattern = new RegExp(`cid:.*${escapeRegExp(fileName)}`, "i");
                                                                        return !cidPattern.test(email.content || "");
                                                                    })
                                                                    .map((attachment) => (
                                                                        <Link
                                                                            key={attachment.id}
                                                                            onClick={() => handleDownloadAttachment(attachment.id || "", attachment.fileName)}
                                                                            sx={{
                                                                                cursor: "pointer",
                                                                                padding: "6px 12px",
                                                                                border: "1px solid #ccc",
                                                                                borderRadius: "8px",
                                                                                borderColor: "var(--color-blue)",
                                                                                textDecoration: "none",
                                                                                display: "inline-flex",
                                                                                alignItems: "center",
                                                                                whiteSpace: "nowrap",
                                                                                "&:hover": {
                                                                                    backgroundColor: "white"
                                                                                }
                                                                            }}
                                                                        >
                                                                            {attachment.fileName}
                                                                        </Link>
                                                                    ))}
                                                            </Box>
                                                        )}
                                                    </Box>

                                                    {/* Email Body (Content) */}
                                                    {expandedEmails[email.id] && (
                                                        <Box sx={{ width: "100%", mt: 0, padding: "0px" }}>
                                                            {emailContents[email.id] ? (
                                                                <div
                                                                    dangerouslySetInnerHTML={{
                                                                        __html: DOMPurify.sanitize(
                                                                            emailContents[email.id].replace(/\n/g, "<br />")
                                                                        ),
                                                                    }}
                                                                    style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", width: "100%" }}
                                                                />
                                                            ) : (
                                                                <Typography variant="body2"><i>Loading…</i></Typography>
                                                            )}
                                                        </Box>
                                                    )}

                                                </ListItem>

                                            </React.Fragment>


                                        )
                                    })}
                            </>

                 ) : (
                     <ListItem>
                         <ListItemText primary={t("No emails found")} />
                     </ListItem>
                 )}


                    </List>
            </Box>
         </Box>

         <Dialog open={showAttachmentDialog} onClose={() => setShowAttachmentDialog(false)} maxWidth="md" fullWidth>
            <DialogTitle>Attachments</DialogTitle>
                <DialogContent>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                <TableCell>Date</TableCell>
                                <TableCell>From</TableCell>
                                <TableCell>Attachment</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredAttachments.map((att, index) => {
                                const isSelected = selectedBlobAttachments.some(a => a.fileUrl === att.fileUrl);
                                return (
                                    <TableRow key={index}>
                                        <TableCell>
                                            <input
                                                type="checkbox"
                                                checked={isSelected}
                                                onChange={(e) => {
                                                    if (e.target.checked) {
                                                        setSelectedBlobAttachments(prev => [...prev, att]);
                                                    } else {
                                                        setSelectedBlobAttachments(prev =>
                                                            prev.filter(a => a.fileUrl !== att.fileUrl)
                                                        );
                                                    }
                                                }}
                                            />
                                        </TableCell>
                                        <TableCell>{att.date ? new Date(att.date + "Z").toLocaleString() : ""}</TableCell>
                                        <TableCell>{getDisplayName(att.from, contacts)}</TableCell>
                                        <TableCell>
                                            <Link onClick={() => handleDownloadAttachment(att?.id || "", att.fileName)}>{att.fileName}</Link>
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                    <Button
                        variant="contained"
                        color="primary"
                        sx={{ mt: 2 }}
                        onClick={() => {
                            enqueueSnackbar(`${selectedBlobAttachments.length} files attached.`, { variant: "info" });
                            setShowAttachmentDialog(false);
                        }}
                    >
                        Attach Selected
                    </Button>
                </DialogContent>
   
            </Dialog>
            <Dialog
                open={Boolean(draftToDelete)}
                onClose={() => setDraftToDelete(null)}
            >
                <DialogTitle>{t("Confirm Delete")}</DialogTitle>
                <DialogContent>
                    <Typography>{t("Are you sure you want to delete this draft?")}</Typography>
                    <Box display="flex" justifyContent="flex-end" gap={1} mt={2}>
                        <Button
                            onClick={() => setDraftToDelete(null)}
                            variant="outlined"
                        >
                            {t("Cancel")}
                        </Button>
                        <Button
                            onClick={async () => {
                                if (draftToDelete) {
                                    await handleDeleteDraft(draftToDelete.id);
                                    setDraftToDelete(null);
                                }
                            }}
                            variant="contained"
                            color="error"
                        >
                            {t("Delete")}
                        </Button>
                    </Box>
                </DialogContent>
            </Dialog>

            <CustomerDialog
                open={showCustomerDialog}
                customer={newCustomer}
                onClose={() => setShowCustomerDialog(false)}
                allowSurvey={
                    parseInt(settings["CustomerSatisfactionSurvey:SurveySendingDays"] ?? "-1", 10) >= 0
                } 
                onSaved={(createdCustomer: Customer) => {
                    //setCustomers(prev => [...prev, createdCustomer]); // add new customer to list
                    setCustomers(prev =>
                        prev.some(c => c.id === createdCustomer.id)
                            ? prev.map(c => c.id === createdCustomer.id ? createdCustomer : c)
                            : [...prev, createdCustomer]
                    );
                    onUpdateCustomerForOrder(createdCustomer.id ?? ""); // ✅ update order.customerId
                    setShowCustomerDialog(false);
                }}
            />
            <AddContactDialog
                open={addContactDialogOpen}
                onClose={() => {
                    setAddContactDialogOpen(false);
                    //setSelectedContact(null);
                }}
                customerId={selectedOrder?.customerId || ""}
                email={pendingEmail || ""}
                allowSurvey={
                    parseInt(settings["CustomerSatisfactionSurvey:SurveySendingDays"] ?? "-1", 10) >= 0
                } 
                onContactAdded={(newContact) => {
                    setContacts(prev => [...prev, newContact]);
                    setAddContactDialogOpen(false);
                    //setSelectedContact(null);
                }}
                //onContactUpdated={(updatedContact) => {
                //    setContacts(prev =>
                //        prev.map(c => c.id === updatedContact.id ? updatedContact : c)
                //    );
                //    setAddContactDialogOpen(false);
                //    //setSelectedContact(null);
                //}}
            />
            <AddIgnoreDialog
                open={showIgnoreDialog}
                onClose={() => setShowIgnoreDialog(false)}
                onSave={async (type, value) => {
                    try {
                        const token = localStorage.getItem("token");
                        await axiosExt.post(`${API_BASE_URL}/IgnoreList`, { type, value }, {
                            headers: { Authorization: `Bearer ${token}` },
                        });
                        enqueueSnackbar(t("Added to ignore list."), { variant: "success" });
                    } catch (err) {
                        console.error("Failed to ignore email/domain", err);
                        enqueueSnackbar(t("Failed to ignore."), { variant: "error" });
                    } finally {
                        setShowIgnoreDialog(false);
                        setIgnoreEmail(null);
                    }
                }}
                initialType={"Email"}
                initialValue={ignoreEmail ?? ""}
            />
            {showFieldPopup && (
                <FieldSelectionPopup
                    position={popupPosition}
                    selectedText={selectedText}
                    onFieldValueSelected={(field, value) => {
                        onFieldValueSelected(field, value);
                        setShowFieldPopup(false);
                    }}
                    onClose={() => setShowFieldPopup(false)}
                />
            )}
        </>
    );
};

export default EmailConversation;
